import axios from "axios";
import { profileUrl } from "./utils";

const getUser = () => new Promise((resolve, reject) => {
    axios.get(profileUrl, {
        headers: {
            Accept: 'application/json',
            'Application-URL': window.location.href,
        }
    }).then(res => resolve(res.data)).catch(err => reject(err));
});

export const userClient = {
    getUser,
};
